import * as Yup from 'yup';
import VALUE_TYPES from '../../configs/ValueTypeConstants';

const dailyFeeCollectionState = {
    school_id: null,
    mode_of_pays: null,
    start_date: null,
    end_date: null,
};

const dailyFeeCollectionSchema = Yup.object().shape({
    school_id: Yup.number().required(),
    mode_of_pays: Yup.array().min(1).required(),
    start_date: Yup.date().required(),
    end_date: Yup.date().required(),
});

const dailyFeeCollectionFormFields = [
    { name: "school_id", title: "Schools", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "mode_of_pays", title: "Mode Of Pay", required: true, type: VALUE_TYPES.MULTISELECT, options: [], apiRequired: true, displayKey: "mode_of_pay", itemValue: "id" },
    { name: "start_date", title: "Start Date", required: true, type: VALUE_TYPES.DATEPICKER, disabled: false },
    { name: "end_date", title: "End Date", required: true, type: VALUE_TYPES.DATEPICKER, disabled: false },
];

export const dailyFeeCollectionConfig = {
    "state": dailyFeeCollectionState,
    "schema": dailyFeeCollectionSchema,
    "formFields": dailyFeeCollectionFormFields
};

const outstandingFeeCollectionState = {
    school_id: null,
    academic_year_id: null,
};

const outstandingFeeCollectionSchema = Yup.object().shape({
    school_id: Yup.number().required(),
    academic_year_id: Yup.number().required(),
});

const outstandingFeeCollectionFormFields = [
    { name: "school_id", title: "Schools", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "academic_year_id", title: "Academic Year", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "academic_year", itemValue: "id" },
];

export const outstandingFeeCollectionConfig = {
    "state": outstandingFeeCollectionState,
    "schema": outstandingFeeCollectionSchema,
    "formFields": outstandingFeeCollectionFormFields
};

const missingInvoicesState = {
    school_id: null,
    term_id: null,
};

const missingInvoicesSchema = Yup.object().shape({
    school_id: Yup.number().required(),
    term_id: Yup.number().required(),
});

const missingInvoicesFormFields = [
    { name: "school_id", title: "School", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "term_id", title: "Term", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
];

export const missingInvoicesConfig = {
    "state": missingInvoicesState,
    "schema": missingInvoicesSchema,
    "formFields": missingInvoicesFormFields
};

const otherFeesState = {
    school_id: null,
    start_date: null,
    end_date: null,
};

const otherFeesSchema = Yup.object().shape({
    start_date: Yup.date().required(),
    end_date: Yup.date().required(),
});

const otherFeesFormFields = [
    { name: "school_id", title: "School (optional)", required: false, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" },
    { name: "start_date", title: "Start Date", required: true, type: VALUE_TYPES.DATEPICKER, disabled: false },
    { name: "end_date", title: "End Date", required: true, type: VALUE_TYPES.DATEPICKER, disabled: false },
];

export const otherFeesConfig = {
    "state": otherFeesState,
    "schema": otherFeesSchema,
    "formFields": otherFeesFormFields
};
